<a href="tel:{{ phone }}" data-testid="support-contact-number">{{ phone }}</a>
